import { HttpServiceBase } from "./http-service-base";
import { getLogger } from "../common/logging";
import { b64decode, isGuid } from "../b64";
let log = getLogger("application-service");

export class SignatureService extends HttpServiceBase {
  constructor(...rest) {
    super(...rest);
  }
  version = "v2";
  // version = "http://localhost:9910";

  async sign(referenceId, referenceType, referenceDisplay) {
    if (!isGuid(referenceId)) {
      referenceId = b64decode(referenceId);
    }
    let msg = await this.http.post(`${this.version}/b2sign/sign`, {
      referenceId,
      referenceType,
      referenceDisplay
    });

    return JSON.parse(msg.response);
  }

  async v2sign(display) {
    let msg = await this.http.post(`${this.version}/bankid/sign`, {
      "display" : display
    });
    return JSON.parse(msg.response);
  }
  async v2status(orderRef) {
    let msg = await this.http.get(`${this.version}/bankid/status/${orderRef}`);
    return JSON.parse(msg.response);
  }


  async auth(customerShortName) {
    let msg = await this.http.post(`${this.version}/b2sign/auth`, { customerShortName });
    return JSON.parse(msg.response);
  }

  // cancel bankid auth/sign. id is the bankid order reference
  async cancel(id) {
    await this.http.post(`${this.version}/b2sign/${id}/cancel`);
  }

  async getByReferenceId(referenceId) {
     if (!isGuid(referenceId)) {
       referenceId = b64decode(referenceId);
     }

    var msg = await this.http.get(`${this.version}/signatures/${referenceId}`);
    let data = JSON.parse(msg.response);
    data = data
      .filter(
        (item) => item.bankIdOrderRef !== "00000000-0000-0000-0000-000000000000"
      )
      .sort((a, b) => b.created - a.created);

    return data;
  }

  async signstatus(orderRef) {
    let msg = await this.http.get(
      `${this.version}/b2sign/${orderRef}/signstatus`
    );

    return JSON.parse(msg.response);
  }
}
